import AutoComplete from "primevue/autocomplete";
import PrimeVue from "primevue/config";
import Vue from "vue";
Vue.use(PrimeVue);
Vue.component("AutoComplete", AutoComplete);
